module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-full-cal-event-panel"
  }, [_c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [(_vm.eventId) ? _c('DCalendarShowEvent', {
    attrs: {
      "isInitEventLoading": !_vm.event || _vm.isEventsLoading,
      "event": _vm.event,
      "initCalendarId": _vm.calendarId
    },
    on: {
      "submitDeleteEventOnward": _vm.onEventUpdated,
      "close": _vm.onClose,
      "updated": _vm.onEventUpdated
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4aaa3027!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/DShowEventFullCal.vue
// module id = 1585
// module chunks = 1